import { Card, Spin } from "antd";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import GrnConnectSpinningLogo from "../../assets/img/grnConnectSpinningLogo.svg";
import engLang from "../../locales/languages/Dashboard/DashboardEng.json";
import spanLang from "../../locales/languages/Dashboard/DashboardSpan.json";
import { RootState } from "../../store/rootReducer";
import { useLanguageCode } from "../CustomHooks/ProfileHook";
import loadingGif from "../../assets/img/static/loadingAnimation.gif";

interface LoaderProps {
  block: boolean;
  tableList?: boolean;
  type?: string;
}

const Loader: React.FC<LoaderProps> = ({ block, tableList, type = "" }) => {
  const { t } = useTranslation();
  const languageCode = useLanguageCode();

  const langSelected = useSelector(
    (state: RootState) => state.languageVariable
  );
  const langType = (languageCode() || langSelected?.value) == "en" ? engLang : spanLang;

  return (
    <Fragment>
      {tableList ? (
        block && (
          // <div className="ui-loader">
          //   <img className="loader-img" src={AppLogoIcon} alt="Loading...." />
          // </div>
          <div className="loader7">
            <img src={GrnConnectSpinningLogo} alt="GRNconnect" />
          </div>
        )
      ) : (
        // <Spin
        //   indicator={
        //     <img className="loader-img" src={AppLogoIcon} alt="Loading...." />
        //   }
        //   spinning={block}
        //   fullscreen
        // />

        // <Spin
        //   className="loader7"
        //   indicator={
        //     <img
        //       className="loader-logo"
        //       src={GrnConnectSpinningLogo}
        //       alt="GRNconnect"
        //     />
        //   }
        //   spinning={block}
        //   fullscreen
        // />

        <Spin
          className="loader7"
          indicator={
            <Card
              className="progress-bar-card"
              style={{ width: 350, height: "auto", padding: "10px" }}
            >
              <img
                className="mx-auto h-[150px]"
                src={loadingGif}
                alt="GRNconnect"
              />
              <div className="loader-message-container">
                {type?.length > 0
                  ? <p className="loader-status !text-[16px]">{type}</p>
                  : <p className="loader-wait-message">{t(langType.Please_wait)}</p>
                }
              </div>
              {/* <div className="progress-loader"></div> */}
            </Card>
          }
          spinning={block}
          fullscreen
        ></Spin>
        // <div className="loader7">
        //   <img
        //     src={loadingGif}
        //     alt="Loading"
        //     className="w-[120px] h-[120px]"
        //   />
        //   <div className="loader-message-container">
        //     {type?.length > 0
        //       ? <p className="loader-status">{type}</p>
        //       : <p className="loader-wait-message">{t(langType.Please_wait)}</p>
        //     }
        //   </div>
        // </div>

      )}
    </Fragment>
  );
};

export default Loader;
